<template>
  <div class="subpage">
    <h1>
      Strona nie istnieje
    </h1>

    <div class="back back--form">
      <router-link to="/">Strona główna</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "page not found",
  title: "Strony nie odnaleziono",
};
</script>
